// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"b8711f49","110":"14a4f8d3","127":"f184f7c8","337":"ba35026b","369":"df02d189","492":"57d50542","692":"cb86230c"}[chunkId] + ".chunk.js";
};